// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import SetCurrentComponent from "@/core/services/SetCurrentComponent";

const cadastro_de_detalhes_da_informacao_complementar = {
  path: "/cadastro-de-detalhes-da-informacao-complementar/:id/visualizar",
  name: "cadastro_de_detalhes_da_informacao_complementar_visualizar",
  meta: {
    breadCrumb: "Gestão - Informação Complementar do Aluno",
  },
  children: [
    {
      path: "/cadastro-de-detalhes-da-informacao-complementar/:id/visualizar",
      name: "cadastro_de_detalhes_da_informacao_complementar_visualizar",
      component: SetCurrentComponent(
        "CadastroDeInformacaoComplementar/Pages/CadastroDeDetalhesDaInformacaoComplementar",
        "CadastroDeDetalheDaInformacaoComplementarHome"
      ),
    },
    {
      path: "/cadastro-de-detalhes-da-informacao-complementar/novo/:infoComplementarId",
      name: "cadastro_de_detalhes_da_informacao_complementar_novo",
      component: SetCurrentComponent(
        "CadastroDeInformacaoComplementar/Pages/CadastroDeDetalhesDaInformacaoComplementar",
        "CadastroDeDetalheDaInformacaoComplementarCadastro"
      ),
    },

    {
      path: "/cadastro-de-detalhes-da-informacao-complementar/:id/:infoComplementarId",
      name: "cadastro_de_detalhes_da_informacao_complementar_editar",
      component: SetCurrentComponent(
        "CadastroDeInformacaoComplementar/Pages/CadastroDeDetalhesDaInformacaoComplementar",
        "CadastroDeDetalheDaInformacaoComplementarEditar"
      ),
    },
  ],
};

export { cadastro_de_detalhes_da_informacao_complementar };
